












































































import Vue from 'vue';
import { auth } from '@/firebaseConfig';
import Sticky from '@/vue-components/util/Sticky.vue';
import CardHeader from '@/vue-components/util/CardHeader.vue';

export default Vue.extend({
  name: 'ChangePassword',
  components: {
    Sticky,
    CardHeader,
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      errorMessage: '',
      success: false,
      processing: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    validated(): boolean {
      if (this.newPassword && this.currentPassword) {
        if (this.newPassword.length >= 6) {
          return true
        }
      }
      return false
    },

    changePassword() {
      console.log('Change password');
      if (this.processing) {
        console.log('Presently processing - ignoring');
        return;
      }

      this.processing = true;

      console.log(this.currentPassword, this.newPassword);
      this.errorMessage='';

      const credential = auth.EmailAuthProvider.credential(
        this.currentUser.email,
        this.currentPassword,
      );

      this.currentUser.reauthenticateWithCredential(credential).then(() => {
        this.currentUser.updatePassword(this.newPassword).then(() => {
          console.log('Password changed');
          this.success = true;
          this.processing = false;
        }).catch((error) => {
          console.log(error);
          this.errorMessage = error.message;
          this.processing = false;
        });
      }).catch((error) => {
        console.log(error);
        this.errorMessage = error.message;
        this.processing = false;
      });

    },
  },
});
